import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Checkbox, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { useCallback } from "react";
import Dropzone from "../common/Dropzone";
import "./test.css";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";
import { TextField, IconButton, Link, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const webserver = ConfigData.WEBSERVER;

export default function CorrectionDialog(props) {
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);
  const theme = useTheme();
  const [file, setFile] = React.useState(null);
  const [multipartFile, setMultipartFile] = React.useState(null);
  const [alignment, setAlignment] = React.useState(null);
  const [descriptionExpanded, setDescriptionExpanded] = React.useState(false);
  const [oldDescription, setOldDescription] = React.useState("");
  const [description, setDescription] = React.useState("");

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/examResult/correctionFilesDescription/" +
        props.examResult,
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then((response) => response.text())
      .then((data) => setOldDescription(data))
      .catch((error) => {
        setGlobalMessage({
          globalMessage: "Anmerkung konnte nicht geladen werden",
          severity: "error",
        });
      });
  }, [props.open]);

  const handleClose = () => {
    props.setOpen();
    props.function();

    const formData = new FormData();
    formData.append("file", multipartFile);
    formData.append("description", description);

    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/examResult/uploadCorrection?resultID=" +
        props.examResult,
      { method: "POST", credentials: "include", body: formData }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then(() => {
        //   setRowss(prev => {
        //     let rowsCopy = JSON.parse(JSON.stringify(prev));
        //     rowsCopy[index].active = activity;
        //     return rowsCopy;
        //   });
        setGlobalMessage({
          globalMessage: "Upload erfolgreich",
          severity: "success",
        });
      })
      .catch((error) => {
        setGlobalMessage({
          globalMessage: "Vorgang fehlgeschlagen",
          severity: "error",
        });
      });
  };

  const onDrop = useCallback((acceptedFiles) => {
    // Loop through accepted files
    acceptedFiles.map((file) => {
      setMultipartFile(file);
      // Initialize FileReader browser API
      const reader = new FileReader();
      // onload callback gets called after the reader reads the file data
      reader.onload = function (e) {
        // add the image into the state. Since FileReader reading process is asynchronous, its better to get the latest snapshot state (i.e., prevState) and update it.
        setFile([file.name, e.target.result]);
      };
      // Read the file as Data URL (since we accept only images)
      reader.readAsBinaryString(file);
      return file;
    });
  }, []);

  return (
    <Dialog open={props.open} onClose={() => props.setOpen()}>
      <DialogTitle>Korrektur herunterladen oder einreichen</DialogTitle>
      <DialogContent sx={{ marginTop: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {oldDescription !== null && oldDescription !== "" ? (
              <Link
                sx={{ width: "120px", height: "120px" }}
                href={
                  webserver.protocol +
                  "://" +
                  webserver.host +
                  ":" +
                  webserver.port +
                  "/examResult/correctionFiles/" +
                  props.examResult
                }
              >
                <IconButton sx={{ padding: 0 }}>
                  <FileDownloadIcon
                    sx={{ width: "100%", height: "100%" }}
                  ></FileDownloadIcon>
                </IconButton>
              </Link>
            ) : (
              "Keine Korrektur vorhanden"
            )}
            {oldDescription !== null && oldDescription !== "" ? (
              <Typography variant="caption" sx={{ alignSelf: "center" }}>
                Herunterladen
              </Typography>
            ) : null}
          </Box>

          {oldDescription !== null && oldDescription !== "" ? (
            <TextField
              sx={{ width: 450, m: 0, marginTop: 3 }}
              size="small"
              multiline={true}
              margin="dense"
              id="correctionDescriptionOld"
              label="Anmerkung"
              type="text"
              value={oldDescription}
              disabled
            />
          ) : null}

          <Box sx={{ marginTop: 5 }}>
            <Dropzone
              onDrop={onDrop}
              file={file}
              accept={{ "application/pdf": [".pdf"] }}
            />
          </Box>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 1 }}>
          <TextField
            sx={{ width: 450, m: 0 }}
            size="small"
            multiline={descriptionExpanded}
            margin="dense"
            id="correctionDescription"
            label="Anmerkung"
            type="text"
            value={description}
            required
            onInput={(e) => {
              setDescription(e.target.value);
            }}
            InputProps={{
              endAdornment: (
                <IconButton
                  sx={{ alignSelf: "flex-start" }}
                  onClick={(e) => {
                    setDescriptionExpanded((prev) => !prev);
                  }}
                >
                  {descriptionExpanded ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </IconButton>
              ),
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => props.setOpen()}
          sx={{ color: theme.palette.mode === "dark" ? "#c4c4c4" : "#666666" }}
        >
          Abbrechen
        </Button>
        <Button
          onClick={handleClose}
          disabled={file === null || description === ""}
        >
          Einreichen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
